module.exports = __webpack_public_path__ + "img/lipstick_and_perfume_2.eacde37d.png";